var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSyncAlt = function SvgSyncAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M9.13 3.93a.75.75 0 0 0-1.06-1.06l1.06 1.06ZM5 7l-.53-.53a.75.75 0 0 0 0 1.06L5 7Zm3.07 4.13a.75.75 0 0 0 1.06-1.06l-1.06 1.06ZM19 7.75a.75.75 0 0 0 0-1.5v1.5Zm-4.13 12.32a.75.75 0 0 0 1.06 1.06l-1.06-1.06ZM19 17l.53.53a.75.75 0 0 0 0-1.06L19 17Zm-3.07-4.13a.75.75 0 1 0-1.06 1.06l1.06-1.06ZM5 16.25a.75.75 0 0 0 0 1.5v-1.5ZM8.07 2.87l-3.6 3.6 1.06 1.06 3.6-3.6-1.06-1.06Zm-3.6 4.66 3.6 3.6 1.06-1.06-3.6-3.6-1.06 1.06ZM19 6.25H5v1.5h14v-1.5Zm-3.07 14.88 3.6-3.6-1.06-1.06-3.6 3.6 1.06 1.06Zm3.6-4.66-3.6-3.6-1.06 1.06 3.6 3.6 1.06-1.06ZM5 17.75h14v-1.5H5v1.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSyncAlt);
export default ForwardRef;